<template>

    <v-row class="fill-height">
        <v-col>
            <v-card>
                <v-card-title>

                    <v-btn small @click="pushRouteToView()" class="mr-4 btn-back">
                        <v-icon>
                            mdi-arrow-left
                        </v-icon>
                        Voltar
                    </v-btn>

                    <v-icon left>mdi-cash-fast</v-icon>
                    Checkout
                    <v-spacer></v-spacer>

                </v-card-title>

                <v-card
                    flat
                >
                    <v-card-title>
                        <b>Cliente: </b> &nbsp;{{ checkoutSchedule.personName }}<br>
                        <v-spacer>
                        </v-spacer>
                        <b>Telefone:</b> {{ checkoutSchedule.personPhone }}
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" xs="12">
                                <b>Profissional: </b> {{ checkoutSchedule.bmName }}
                            </v-col>
                        </v-row>

                        <v-card elevation="0"
                                color="grey lighten-4"
                        >

                            <v-card-text class="pa-2 "
                                         v-show="checkoutSchedule.statusID !== 1 && checkoutSchedule.statusID !== 6 &&  checkoutSchedule.statusID !== 2 && checkoutSchedule.statusID !== 5 && checkoutSchedule.statusID !== 4">
                                <v-row>
                                    <v-col>
                                        Aqui você pode adicionar mais serviços e produtos ao atendimento
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col sm="2" md="2">
                                        <v-radio-group
                                            v-model="itemType"
                                            mandatory
                                            row
                                            @change="resetItem"
                                        >
                                            <v-radio
                                                label="Serviço"
                                                value="service"
                                            ></v-radio>
                                            <v-radio
                                                label="Produto"
                                                value="product"
                                            ></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="12"
                                        md="4"
                                        v-if="itemType=='service'"
                                    >
                                        <v-autocomplete
                                            v-model="item.serviceID"
                                            :items="servicesSimple"
                                            item-value="id"
                                            item-text="name"
                                            label="Serviço"
                                            placeholder="Escolha um serviço"
                                            outlined
                                            dense
                                        >
                                            <template v-slot:selection="{ item }">
                                                {{ item.categoryName }} - {{ item.name }} - {{ item.value | money }}
                                            </template>
                                            <template v-slot:item="{ item }">
                                                {{ item.categoryName }} - {{ item.name }} - {{ item.value | money }}
                                            </template>
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="12"
                                        md="4"
                                        v-if="itemType=='product'"
                                    >
                                        <v-autocomplete
                                            v-model="item.productID"
                                            :items="productsSimple"
                                            item-value="id"
                                            item-text="description"
                                            label="Produto ou insumo"
                                            placeholder="Escolha um produto"
                                            outlined
                                            dense
                                        >
                                            <template v-slot:selection="{ item }">
                                                {{ item.brand }} - {{ item.description }} - {{ item.salesPrice | money }}
                                            </template>
                                            <template v-slot:item="{ item }">
                                                {{ item.brand }} - {{ item.description }} - {{ item.salesPrice | money }}
                                            </template>
                                        </v-autocomplete>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        sm="12"
                                        md="2"
                                    >
                                        <!--                                    <v-text-field-->
                                        <!--                                        label="Quantidade"-->
                                        <!--                                        v-model.number="item.quantity"-->
                                        <!--                                        placeholder="Quantidade"-->
                                        <!--                                        :rules="textRules"-->
                                        <!--                                        -->
                                        <!--                                        outlined-->
                                        <!--                                        dense-->
                                        <!--                                    ></v-text-field>-->


                                        <number-input
                                            outlined
                                            v-model.number="item.quantity"
                                            :rules="textRules"
                                            label="Quantidade"
                                            placeholder="Quantidade"
                                            :options="optionsNumber"
                                            dense
                                        >
                                        </number-input>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="12"
                                        md="2"
                                    >
                                        <!--                                    <v-text-field-->
                                        <!--                                        label="Desconto"-->
                                        <!--                                        v-model.number="item.discount"-->
                                        <!--                                        placeholder="Valor do desconto"-->
                                        <!--                                        outlined-->
                                        <!--                                        dense-->
                                        <!--                                    ></v-text-field>-->

                                        <number-input
                                            outlined
                                            v-model="item.discount"
                                            :rules="textRules"
                                            label="Desconto"
                                            placeholder="Valor do desconto"
                                            :options="optionsMoney"
                                            dense
                                        >
                                        </number-input>

                                    </v-col>
                                    <v-col cols="12"
                                           sm="12"
                                           md="2">
                                        <v-btn
                                            color="success"

                                            @click="itemSave(checkoutSchedule.order.id)"
                                        >
                                            <v-icon left>mdi-plus</v-icon>
                                            Adicionar
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>

                        <div class="d-flex justify-space-between">
                            <div><b>Itens:</b></div>
                            <div>
                                <!--                            <v-btn text small @click="newItem(checkoutSchedule.bmID)"-->
                                <!--                                   v-if="checkoutSchedule.statusID==3">-->
                                <!--                                <v-icon>mdi-plus</v-icon>-->
                                <!--                                Adicionar-->
                                <!--                            </v-btn>-->
                            </div>
                        </div>
                        <v-card elevation="0">
                            <v-card-text class="pa-2 grey lighten-4">

                                <v-data-table
                                    :headers="headers"
                                    :items="checkoutSchedule.order.items"
                                    dense
                                    hide-default-footer
                                    class="elevation-0"
                                >
                                    <template v-slot:item.value="{ item }">
                                        {{ item.value | money }}
                                    </template>
                                    <template v-slot:item.discount="{ item }">
                                        {{ item.discount | money }}
                                        <v-btn right icon x-small @click="editItem(item)"
                                               v-show="checkoutSchedule.statusID !== 1 && checkoutSchedule.statusID !== 6 &&  checkoutSchedule.statusID !== 2 && checkoutSchedule.statusID !== 5 && checkoutSchedule.statusID !== 4">
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-btn>
                                    </template>
                                    <template v-slot:item.totalValue="{ item }">
                                        {{ item.totalValue | money }}
                                    </template>

                                    <template v-slot:item.quantity="{ item }">
                                        <v-btn icon x-small color="red" @click="minusItem(item)"
                                               v-show="checkoutSchedule.statusID !== 1 && checkoutSchedule.statusID !== 6 &&  checkoutSchedule.statusID !== 2 && checkoutSchedule.statusID !== 5 && checkoutSchedule.statusID !== 4">
                                            <v-icon>mdi-minus</v-icon>
                                        </v-btn>
                                        {{ item.quantity }}
                                        <v-btn icon x-small color="green" @click="plusItem(item)"
                                               v-show="checkoutSchedule.statusID !== 1 && checkoutSchedule.statusID !== 6 &&  checkoutSchedule.statusID !== 2 && checkoutSchedule.statusID !== 5 && checkoutSchedule.statusID !== 4">
                                            <v-icon>mdi-plus</v-icon>
                                        </v-btn>
                                    </template>

                                </v-data-table>

                                <div class="d-flex justify-space-between mt-2">
                                    <div></div>
                                    <div><b>Total: </b> {{ checkoutSchedule.order.totalValue | money }}</div>
                                </div>
                            </v-card-text>
                        </v-card>

                        <b>Status: </b> {{ status[checkoutSchedule.statusID - 1] }}
                    </v-card-text>
                    <v-card-actions>
                        <!--                            <v-btn-->
                        <!--                                text-->
                        <!--                                color="secondary"-->
                        <!--                                @click="selectedOpen = false"-->
                        <!--                            >-->
                        <!--                                Fechar-->
                        <!--                            </v-btn>-->
                        
                        <v-btn
                            outlined
                            small
                            color="#FF3816"
                            @click="dialogCancel=true"
                            v-show="checkoutSchedule.statusID != 2 && checkoutSchedule.statusID != 5 && checkoutSchedule.statusID != 4"
                        >
                            Cancelar Atendimento
                        </v-btn>

<!--                        <v-btn-->
<!--                            outlined-->
<!--                            small-->
<!--                            color="#FF3816"-->
<!--                            @click="dialogCancelPayment=true"-->
<!--                            v-show="checkoutSchedule.statusID == 4 || checkoutSchedule.statusID == 5"-->
<!--                        >-->
<!--                            Cancelar Cobrança-->
<!--                        </v-btn>-->
                        <v-spacer></v-spacer>

                        <v-spacer></v-spacer>
                        <!--                        <v-btn-->
                        <!--                            dark-->
                        <!--                            :color="colors[checkoutSchedule.statusID-1]"-->
                        <!--                            @click="startAttendance( checkoutSchedule.id)"-->
                        <!--                            v-if="checkoutSchedule.statusID == 7"-->
                        <!--                        >-->
                        <!--                            Reabrir Atendimento-->
                        <!--                        </v-btn>-->
                        <v-btn
                            dark
                            :color="colors[checkoutSchedule.statusID-1]"
                            v-if="checkoutSchedule.statusID == 3"
                            @click="dialogFinishAttendance=true"
                        >
                            Finalizar Atendimento
                        </v-btn>


                    </v-card-actions>
                </v-card>


            </v-card>
        </v-col>

        <confirm-dialog
            :dialog="dialogFinishAttendance"
            title="Deseja finalizar o atendimento?"
            :body="`Finalizar atendimento do cliente ${checkoutSchedule.personName}?`"
            @dialog-event="attendanceFinish">
        </confirm-dialog>

        <confirm-dialog
            :dialog="dialogCancel"
            title="Cancelar Agendamento"
            body="Tem certeza que deseja cancelar este agendamento?"
            confirm-text="Sim"
            cancel-text="Não"
            @dialog-event="scheduleCancel">
        </confirm-dialog>
        
        <confirm-dialog
            :dialog="dialogCancelPayment"
            title="Cancelar Pagamento"
            body="Tem certeza que deseja cancelar a solicitação de pagamento? "
            name="Isso irá cancelar o pagamento de todos os agendamentos agrupados no mesmo pagamento"
            confirm-text="Sim"
            cancel-text="Não"
            @dialog-event="paymentCancel">
        </confirm-dialog>
        
    </v-row>
</template>

<script>
import {mapGetters} from "vuex";
import store from "@/store";
import {mask} from "vue-the-mask";
import NumberInput from "@/components/NumberInput";
import ConfirmDialog from "@/components/ConfirmDialog";


import {CHECKOUT_CHARGE, CHECKOUT_DELETE, CHECKOUT_SCHEDULE_GET} from "@/store/actions/checkout.type";
import {CHECKOUT_RESET_STATE,} from "@/store/mutations/checkout.type";
import {SERVICES_BM_GET} from "@/store/actions/service.type";
import {PRODUCTS_SIMPLE_GET} from "@/store/actions/product.type";
import {SCHEDULE_ADD_ITEM, SCHEDULE_CANCEL, SCHEDULE_FINISH_ATTENDANCE} from "@/store/actions/schedule.type";

export default {
    name: "checkout",
    directives: {mask},
    props: {
        source: String,
        id: {
            default: 0,
            type: Number,
            required: true
        },
        scheduleID: {
            default: 0,
            type: Number,
            required: true
        }
    },

    components: {NumberInput, ConfirmDialog},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        await store.dispatch(CHECKOUT_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {

        Promise.all([
            store.dispatch(CHECKOUT_RESET_STATE),
            store.dispatch(CHECKOUT_SCHEDULE_GET, {personID: to.params.id, scheduleID: to.params.scheduleID}),
            store.dispatch(PRODUCTS_SIMPLE_GET)
        ]).then(() => {
            next();
        });
    },
    data: () => ({
        //Lista de Usuários
        pagination: {
            sortBy: "name"
        },
        dialogFinishAttendance: false,
        dialogCancelPayment: false,
        dialogCancel: false,
        
        itemType: null,
        item: {
            bmId: 0,
            productID: 0,
            serviceID: 0,
            quantity: 1,
            discount: 0
        },

        optionsNumber: {
            locale: "pt-BR",
            prefix: "",
            length: 5,
            precision: 0
        },


        colors: [' purple accent-4', 'red darken-4', 'blue', 'pink accent-2', 'green', 'grey darken-1', 'yellow'],
        status: ['Agendado', 'Cancelado', 'Em Atendimento', 'Aguardando Pagamento', 'Finalizado', 'Ausente', 'Atendimento Finalizado'],

        totalValue: 0,
        ativo: true,
        dialogPayment: false,
        payments: [
            {
                paymentTypeID: 0,
                value: null
            }
        ],
        btnPayDisabled: true,
        options: {},

        selectedIDs: [],
        headers: [
            {text: 'Nome', sortable: false, value: 'name'},
            {text: 'Quantidade', sortable: false, value: 'quantity'},
            {text: 'Valor', sortable: false, value: 'value'},
            {text: 'Desconto', sortable: false, value: 'discount'},
            {text: 'Valor Total', sortable: false, value: 'totalValue'},
        ],

        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        dateFormatted: null,
        menu1: false,
        menu2: false,

        formIsValid: false,

        textRules: [
            v => !!v || "Este campo é obrigatório"
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],
        paymentRules: [
            v => !!v || "Este campo é obrigatório"
        ],
        optionsMoney: {
            locale: "pt-BR",
            prefix: "R$:",
            length: 7,
            precision: 2
        },
        // cpfRule: [
        //     v => !!v || "CPF é obrigatório",
        //     strCPF => {
        //         if (!strCPF) return false;
        //         strCPF = strCPF.replace(/\D/g, "");
        //         let Soma;
        //         let Resto;
        //         Soma = 0;
        //         if (strCPF == "00000000000") return "CPF Inválido";
        //         let i = 0;
        //         for (i = 1; i <= 9; i++)
        //             Soma =
        //                 Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
        //         Resto = (Soma * 10) % 11;
        //
        //         if (Resto == 10 || Resto == 11) Resto = 0;
        //         if (Resto != parseInt(strCPF.substring(9, 10)))
        //             return "CPF Inválido";
        //
        //         Soma = 0;
        //         for (i = 1; i <= 10; i++)
        //             Soma =
        //                 Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
        //         Resto = (Soma * 10) % 11;
        //
        //         if (Resto == 10 || Resto == 11) Resto = 0;
        //         if (Resto != parseInt(strCPF.substring(10, 11)))
        //             return "CPF Inválido";
        //         return true;
        //     }
        // ],
        // emailRules: [
        //     v => !!v || "E-mail é obrigatório",
        //     value => {
        //         if (typeof value !== "undefined" && value.length > 0) {
        //             const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        //             return pattern.test(value) || "Informe um email válido";
        //         }
        //         return false;
        //     }
        // ]
    }),
    methods: {
        paymentCancel(status) {
            this.dialogCancelPayment = false
            if (!status) {
                return
            }

            this.inProgress = true
            this.$store
                .dispatch(CHECKOUT_DELETE, {personID: this.checkoutSchedule.personID, scheduleID: this.checkoutSchedule.id})
                .then(async () => {
                    this.inProgress = false;

                    await this.orderUpdate()

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Pagamento cancelado com sucesso.";
                    this.selectedOpen = false
                    this.dialog = false;
                    this.dialogCancel = false;
                })
                .catch(({response}) => {
                    this.inProgress = false;
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao cancelar.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text =
                            "Erro: " +
                            response.data.message;
                    }
                });
        },
        scheduleCancel(status) {
            this.dialogCancel = false
            if (!status) {
                return
            }
            let id = this.checkoutSchedule.id;

            this.inProgress = true
            this.$store
                .dispatch(SCHEDULE_CANCEL, id)
                .then(async () => {
                    this.inProgress = false;

                    await this.orderUpdate()

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Cancelado com sucesso";
                    this.selectedOpen = false
                    this.dialog = false;
                    this.dialogCancel = false;
                })
                .catch(({response}) => {
                    this.inProgress = false;
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao cancelar.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text =
                            "Erro: " +
                            response.data.message;
                    }
                });
        },
        
        editItem(item) {

            this.item = {
                bmID: item.bmID,
                productID: item.productID,
                serviceID: item.serviceID,
                quantity: item.quantity,
                discount: item.discount,
            }

            if (item.serviceID) {
                this.itemType = 'service'
            }
            if (item.productID) {
                this.itemType = 'product'
            }

            console.log(this.item)
            console.log(this.item.productID, this.item.serviceID)
            //
            //
        },
        plusItem(item) {

            let itemSend = {
                id: this.checkoutSchedule.order.id,
                item: {
                    bmId: item.bmId,
                    productID: item.productID,
                    serviceID: item.serviceID,
                    quantity: item.quantity + 1,
                    discount: item.discount,
                },
            }
            this.$store
                .dispatch(SCHEDULE_ADD_ITEM, itemSend)
                .then(async () => {
                    this.inProgress = false;

                    await this.orderUpdate()

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Atualizado com sucesso";
                    this.resetItem();
                    this.dialogItems = false;

                })
                .catch(({response}) => {
                    this.inProgress = false;
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao atualizar novo item.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text =
                            "Erro: " +
                            response.data.message;
                    }
                });
        },
        minusItem(item) {

            let itemSend = {
                id: this.checkoutSchedule.order.id,
                item: {
                    bmId: item.bmId,
                    productID: item.productID,
                    serviceID: item.serviceID,
                    quantity: item.quantity - 1,
                    discount: item.discount,
                },
            }
            this.$store
                .dispatch(SCHEDULE_ADD_ITEM, itemSend)
                .then(async () => {
                    this.inProgress = false;

                    await this.orderUpdate()

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Atualizado com sucesso";
                    this.resetItem();
                    this.dialogItems = false;

                })
                .catch(({response}) => {
                    this.inProgress = false;
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao atualizar novo item.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text =
                            "Erro: " +
                            response.data.message;
                    }
                });
        },
        itemSave() {
            this.item.bmId = this.checkoutSchedule.bmID


            // console.log(schedule)
            this.inProgress = true
            if (this.item.serviceID === 0 && this.item.productID === 0) {
                this.inProgress = false;
                this.snackbar.snackbar = true;
                this.snackbar.color = "error";
                this.snackbar.text = "Nenhum serviço ou produto escolhido.";
                return
            }
            let item = {
                id: this.checkoutSchedule.order.id,
                item: this.item
            }
            this.$store
                .dispatch(SCHEDULE_ADD_ITEM, item)
                .then(async () => {
                    this.inProgress = false;

                    await this.orderUpdate()

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Salvo com sucesso";
                    this.resetItem();
                    this.dialogItems = false;

                })
                .catch(({response}) => {
                    this.inProgress = false;
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao salvar novo item.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text =
                            "Erro: " +
                            response.data.message;
                    }
                });
        },
        attendanceFinish(status) {
            this.dialogFinishAttendance = false
            if (!status) {
                return
            }
            let id = this.checkoutSchedule.id

            this.inProgress = true

            this.$store
                .dispatch(SCHEDULE_FINISH_ATTENDANCE, id)
                .then(async () => {
                    this.inProgress = false;

                    await this.orderUpdate()

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Atendimento finalizado com sucesso";
                    this.resetItem();

                    this.dialogItems = false;
                    this.dialogPayment = false;
                    this.dialogSchedule = false;

                })
                .catch(({response}) => {
                    this.inProgress = false;
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao alterar atendimento.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text =
                            "Erro: " +
                            response.data.message;
                    }
                });
        },

        resetItem() {
            this.item = {
                bmId: 0,
                productID: 0,
                serviceID: 0,
                quantity: 1,
                discount: 0
            }
        },

        async orderUpdate() {
            await store.dispatch(CHECKOUT_SCHEDULE_GET, {
                personID: this.checkoutSchedule.personID,
                scheduleID: this.checkoutSchedule.id
            })
        },
        pushRouteToView() {
            this.$router.push({name: "checkoutPerson", params: {id: this.id}});
        },
        resetPayment() {
            this.totalValue = 0;
            this.$refs.formPayment.resetValidation();
            this.payments = [{
                paymentTypeID: 0,
                value: null
            }]

        },
        checkBtnDisable() {
            if (this.selectedIDs.length) {
                this.btnPayDisabled = false
                return
            }
            this.btnPayDisabled = true
        },
        addPayment() {
            if (this.payments.length <= this.paymentTypes.length) {
                this.payments.push({paymentTypeID: 0, value: null})
            }
        },
        removePayment(index) {
            if (this.payments.length > 1) {
                this.payments.splice(index, 1)
            }
        },
        payment() {
            // for (let i = 0; i < this.selectedIDs.length; i++) {
            //     for (let j = 0; j < this.checkoutSchedules.items.length; j++) {
            //         if (this.checkoutSchedules.items[j].id == this.selectedIDs[i]) {
            //             this.totalValue = this.totalValue + this.checkoutSchedules.items[j].totalValue
            //         }
            //     }
            // }
        },
        paymentSave() {

            if (this.$refs.formPayment.validate()) {

                // this.inProgress = true
                let payData = {
                    id: this.id,
                    obj: {
                        ids: this.selectedIDs,
                        payments: this.payments
                    }
                }


                this.$store
                    .dispatch(CHECKOUT_CHARGE, payData)
                    .then(async () => {
                        this.inProgress = false;

                        this.snackbar.snackbar = true;
                        this.snackbar.color = "success";
                        this.snackbar.text = "Cobrança registrada com sucesso";
                        this.$refs.formPayment.resetValidation();

                        this.dialogItems = false;
                        this.dialogPayment = false;
                        this.buscar();

                    })
                    .catch(({response}) => {
                        this.dialogPayment = false;
                        this.inProgress = false;
                        this.snackbar.snackbar = true;
                        this.snackbar.color = "error";
                        this.snackbar.text = "Erro ao salvar pagamentos.";
                        // console.log(response.data);
                        if (typeof response.data.message !== "undefined") {
                            this.snackbar.text =
                                "Erro: " +
                                response.data.message;
                        }
                    });
            } else {
                this.snackbar.snackbar = true;
                this.snackbar.color = "error";
                this.snackbar.text = "Preencha o formulário corretamente";
            }
        },
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate(date) {
            if (!date) return null

            const [day, month, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },

        //Methods Lista Usuarios
        // toggleAll() {
        //     if (this.selected.length) this.selected = [];
        //     else this.selected = this.dados.slice();
        // },
        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending;
            } else {
                this.pagination.sortBy = column;
                this.pagination.descending = false;
            }
        },
        buscar() {
            
        },

        reset() {
            this.$refs.formUsuario.reset();
        }
    },
    mounted() {
        this.dateFormatted = this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10))
        this.$store.dispatch(SERVICES_BM_GET, this.checkoutSchedule.bmID)
    },
    watch: {
        options: {
            handler() {
                this.buscar()
            },
            deep: true,
        },
        date() {
            this.dateFormatted = this.formatDate(this.date)
        },
    },
    computed: {
        // ...mapState({
        //   courses: state => state.
        // })

        ...mapGetters(["snackbar", "checkoutSchedule", "checkUsers", "paymentTypes", "servicesSimple", "productsSimple"])
    },
};
</script>
